import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import useIsMobile from "../hooks/useIsMobile";
import Reveal from "../components/common/Reveal";
import SectionTag from "../components/common/SectionTag";
import Icon from "../components/common/Icon";
import Seo from "../components/common/Seo";
import { SERVICES } from "../data/constants";
import { colors, fonts, emphasis, sectionPad, maxW, springHover, cellHover, iconPop, arrowSlide } from "../styles/theme";

export default function ServicesPage() {
  const mob = useIsMobile();
  return (
    <div style={{ background: colors.paper, minHeight: "100vh", paddingTop: 74 }}>
      <Seo
        title="Services | Charith"
        description="Full-spectrum digital services from Charith — web development, cloud solutions, e-commerce, mobile apps, UI/UX design, and our internship program."
        path="/services"
      />
      <section style={{ background: colors.paper, ...sectionPad(mob) }}>
        <Reveal style={{ ...maxW, maxWidth: 720 }}>
          <SectionTag>What We Offer</SectionTag>
          <h1 style={{ fontFamily: fonts.display, fontWeight: 600, fontSize: mob ? 32 : "clamp(30px,4.2vw,54px)", lineHeight: 1.12, color: colors.ink, letterSpacing: "-.01em", marginBottom: 18 }}>
            Full-spectrum <span style={emphasis}>digital services</span>
          </h1>
          <p style={{ color: colors.inkDim, fontFamily: fonts.body, fontSize: mob ? 15 : 17, maxWidth: 480, lineHeight: 1.75 }}>From idea to deployment — we're with you every step.</p>
        </Reveal>
      </section>
      <section style={{ background: colors.paper, padding: mob ? "0 6% 56px" : "0 6% 96px" }}>
        <div style={{ ...maxW, display: "grid", gridTemplateColumns: mob ? "1fr" : "repeat(2,1fr)", border: `1px solid ${colors.borderStrong}`, borderRadius: 6, overflow: "hidden" }}>
          {SERVICES.map((s, i) => {
            const rightBorder = !mob && i % 2 === 0;
            const topBorder = i > (mob ? 0 : 1);
            return (
              <Reveal key={i} delay={i * 0.06} style={{ borderRight: rightBorder ? `1px solid ${colors.borderStrong}` : "none", borderTop: topBorder ? `1px solid ${colors.borderStrong}` : "none" }}>
                <motion.div initial="rest" whileHover="hover" variants={cellHover} transition={springHover} style={{ padding: mob ? 26 : 34, height: "100%" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 18 }}>
                    <motion.div variants={iconPop} transition={springHover} style={{ display: "inline-flex" }}>
                      <Icon name={s.icon} size={26} style={{ color: s.color }} />
                    </motion.div>
                    <span style={{ fontFamily: fonts.display, fontStyle: "italic", fontSize: 18, color: colors.inkFainter }}>{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <h3 style={{ fontFamily: fonts.body, fontWeight: 700, fontSize: mob ? 17 : 19, color: colors.ink, marginBottom: 11 }}>{s.title}</h3>
                  <p style={{ color: colors.inkFaint, fontFamily: fonts.body, fontSize: mob ? 13.5 : 14.5, lineHeight: 1.75, marginBottom: 20 }}>{s.desc}</p>
                  <Link to="/contact" style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "none", border: `1px solid ${colors.borderStrong}`, color: colors.ink, fontFamily: fonts.body, fontSize: 12.5, fontWeight: 600, padding: "8px 16px", borderRadius: 3, textDecoration: "none" }}>
                    Get a Quote <motion.span variants={arrowSlide} transition={springHover} style={{ display: "flex" }}><Icon name="ArrowRight" size={13} /></motion.span>
                  </Link>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}
